import { ContentfulAsset } from '@jbhi-fi/apis/src/contentful/types';
import { ContentfulImageProps } from '../../ContentfulImage/ContentfulImage';
import { VideoPlayerProps } from '../../VideoPlayer/VideoPlayer';

export abstract class AssetTransformer {
  static toImageProps = (entry?: ContentfulAsset): { src: string; alt: string } | undefined => {
    return entry?.fields?.file?.url
      ? {
          src: entry?.fields?.file?.url ?? '',
          alt: entry?.fields?.title ?? '',
        }
      : undefined;
  };

  static toContentfulImageProps = (entry?: ContentfulAsset): ContentfulImageProps | undefined => {
    const { width, height } = entry?.fields?.file?.details?.image ?? {};
    const imgProps = this.toImageProps(entry);
    return imgProps?.src
      ? {
          ...imgProps,
          originalWidth: width,
          aspectRatio: width && height ? width / height : undefined,
          sizes: `(max-width: 800px) 100vw, 1124px`,
        }
      : undefined;
  };

  static toVideoPlayerProps = (entry?: ContentfulAsset): VideoPlayerProps => {
    return {
      src: entry?.fields?.file?.url ?? '',
      type: entry?.fields?.file?.contentType || 'video/mp4',
    };
  };
}
